import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { ROTTA_CANTIERI, ROTTA_PIANO } from './limiteCantieri';

// CAP-018 — finestra «limite cantieri raggiunto» (Regola 14: mai l'alert col JSON).
// `info` e' il risultato di `limiteCantieriDaErrore`: titolo e testo arrivano dal
// backend (CMS di AIstotele). Tre azioni: piano a pagamento, lista cantieri, chiudi.
// `onVaiCantieri` (opzionale): chi e' GIA' sulla lista cantieri chiude il proprio
// form invece di navigare sulla stessa pagina.
export default function LimiteCantieriModal({ info, onClose, onVaiCantieri }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!info) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [info, onClose]);

  if (!info) return null;

  const vai = (rotta) => { onClose(); navigate(rotta); };
  const vaiCantieri = () => {
    onClose();
    if (onVaiCantieri) onVaiCantieri();
    else navigate(ROTTA_CANTIERI);
  };

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1100 }} />
      <div
        role="dialog" aria-modal="true" aria-labelledby="limite-cantieri-titolo"
        data-testid="limite-cantieri-modal"
        style={{
          position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: 'min(92vw, 460px)', maxHeight: '85vh', overflowY: 'auto', zIndex: 1101,
          background: 'var(--ds-bg)', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-card)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)', padding: 24, display: 'flex', flexDirection: 'column', gap: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
          <h2 id="limite-cantieri-titolo" style={{ margin: 0, fontSize: 17, fontWeight: 500, fontFamily: 'var(--font-display)', color: 'var(--ink)', lineHeight: 1.3 }}>
            {info.titolo}
          </h2>
          <button onClick={onClose} aria-label="Chiudi" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ds-muted)', padding: 0, minWidth: 44, minHeight: 44, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <X size={20} strokeWidth={2} />
          </button>
        </div>
        <p style={{ margin: 0, fontSize: 14, fontWeight: 400, color: 'var(--ds-text)', lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>
          {info.testo}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>
          <button onClick={() => vai(ROTTA_PIANO)} style={btnPrimario}>Passa al piano a pagamento</button>
          <button onClick={vaiCantieri} style={btnSecondario}>Archivia un cantiere</button>
          <button onClick={onClose} style={btnTerziario}>Chiudi</button>
        </div>
      </div>
    </>
  );
}

const btnBase = {
  minHeight: 44, padding: '10px 18px', borderRadius: 'var(--radius-base)', fontSize: 14,
  fontWeight: 500, fontFamily: 'inherit', cursor: 'pointer', width: '100%',
};
const btnPrimario = { ...btnBase, border: 'none', background: 'var(--brand)', color: '#fff' };
const btnSecondario = { ...btnBase, border: '1px solid var(--ds-border)', background: 'var(--ds-bg)', color: 'var(--ink)' };
const btnTerziario = { ...btnBase, border: 'none', background: 'none', color: 'var(--ds-muted)', fontWeight: 400 };
